export default __webpack_public_path__ + "static/media/money.24e5b884.jpg";